import { Box, SxProps, Theme } from "@mui/material";
import { ReactNode, forwardRef } from "react";

interface AppPopoverContentProps {
  /** If `true`, default styles are used. Pass `false` to don't use any styles or provide your own styles.
   * @default true
   */
  isUseDefaultStyles?: boolean;
  sx?: SxProps<Theme>;
  children: ReactNode;
}

/** Wraps the content of tooltip. Provides default styling. */
export default forwardRef<HTMLDivElement, AppPopoverContentProps>(function AppTooltipContent(
  { isUseDefaultStyles = true, sx, children }: AppPopoverContentProps,
  ref,
) {
  return (
    <Box
      ref={ref}
      sx={{
        ...(isUseDefaultStyles
          ? {
              maxWidth: { xxs: "95vw" },
              maxHeight: { xxs: "95vh", md: 400, lg: 600 },
              overflowX: "hidden",
              overflowY: "auto",
              wordWrap: "inherit",
            }
          : undefined),
        ...sx,
      }}
    >
      {children}
    </Box>
  );
});
